import { useCallback } from 'react'

export default function ReorderableAndHideableComponent({
  collection,
  onHideItem: doHideItem,
  onShowItem: doShowItem,
  index,
  itemComponent: ItemComponent,
  isInEditMode,
  itemKey,
  itemProps,
  isVisible,
}) {
  const onHideItem = useCallback(() => doHideItem(itemKey), [
    doHideItem,
    itemKey,
  ])
  const onShowItem = useCallback(() => doShowItem(itemKey), [
    doShowItem,
    itemKey,
  ])
  // We wrap because ItemComponent might not render a DOM element.
  return (
    <div>
      <ItemComponent
        collection={collection}
        onHideItem={onHideItem}
        onShowItem={onShowItem}
        index={index}
        isVisible={isVisible}
        isInEditMode={isInEditMode}
        itemKey={itemKey}
        {...itemProps}
      />
    </div>
  )
}
